import { BaseClass } from '/src/components/BaseClass.js';
const slotStyle = new CSSStyleSheet();
slotStyle.replaceSync(`
 r-modal .content [data-modal-title] {
    font-size: 24px;
    margin-bottom: 20px;
    font-weight: bold;
  }
`);
const stylesheet = new CSSStyleSheet();
stylesheet.replaceSync(`
  :host {
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: var(--color-block);
    width: 100dvw;
    height: 100dvh;
    z-index: 10000;
    display: flex;
  }

  ::slotted(.content) {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .intrinsic {
    max-width: 700px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 14px;
    margin: 0 auto;

    & > * {
      width: 100%;
    }
  }

  .title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .top {
    margin-bottom: 10px;
  }

  .content {
    overflow: auto;
    flex-grow: 1;
    min-height: 0;
    margin: 0 auto;
    display: flex;
  }

  .footer {
    margin-top: 10px;
  }
`);
export class RModalContentTemplate extends BaseClass {
    title;
    constructor() {
        super();
        this.shadowRoot.adoptedStyleSheets.push(stylesheet);
        this.title = this.getAttribute('title');
    }
    connectedCallback() {
        this.shadowRoot.innerHTML = `
      <div class="intrinsic">
        <div class="top">
          ${this.title ? `<div class="title">${this.title}</div>` : ''}
          <div class="header">
            <slot name="header"></slot>
          </div>
        </div>
        <div class="content">
          <slot></slot>
        </div>
       <div class="footer">
         <slot name="footer"></slot>
       </div>
     </div>
    `;
    }
    #addStylesToRootNode() {
        const adoptedStylesheets = this.getRootNode().adoptedStyleSheets;
        if (!adoptedStylesheets)
            this.getRootNode().adoptedStyleSheets = [slotStyle];
        else
            this.getRootNode().adoptedStyleSheets.push(slotStyle);
    }
}
customElements.define('r-modal-content-template', RModalContentTemplate);
